import { BybitWalletChain } from '@/types/walletType';
import { TextLink, Button } from '@bfe/moly';
import { useFm, useWallet } from '@web3/base-hooks';
import { useMemo } from 'react';
import { BybitWalletEx } from '@/config/common';
import { WalletChainTypes, WalletType } from '@web3/base-utils';
// import { useWalletInfo } from '@web3/base-provider';

type ISwitchWalletButton = {
  type: 'textlink' | 'button';
  walletTypeList: WalletType[];
  onOk?: () => void;
};

export function SwitchWalletButton(props: ISwitchWalletButton) {
  const { type = 'textlink', walletTypeList } = props;
  // const walletInfoBase = useWalletInfo();
  const {
    isLogin,
    evmWalletInfo,
    isBrowserWallet,
    isCreatedCloudWallet,
    cloudConnected,
    thirdConnected,
    switchToBrowser,
    openLoginModal,
    isBybitWalletExtension,
    createWallet,
    disconnectThird,
    connectBybitWallet,
    walletType,
    switchToThirdParty,
  } = useWallet();
  const fm = useFm();
  // 是否云钱包已登陆
  // 登录了云钱包判断是否已创建云钱包
  // console.log(isCreatedCloudWallet);
  // 插件钱包连接

  // console.log('thirdConnected===>', thirdConnected);

  // 支持全部钱包
  const supportAll = useMemo(() => {
    let flag = true;
    [WalletType.CLOUD, ...BybitWalletEx].forEach((item) => {
      if (!walletTypeList.includes(item)) {
        flag = false;
      }
    });
    return flag;
  }, [walletTypeList]);

  // 仅支持钱包条件
  const onlySupport = useMemo(
    () => ({
      // 仅支持云钱包
      cloud:
        walletTypeList.length === 1 && walletTypeList[0] === WalletType.CLOUD,
      // 仅支持插件钱包
      bybitWalletEx: !walletTypeList.includes(WalletType.CLOUD),
    }),
    [walletTypeList]
  );

  // bybit插件钱包切换钱包类型
  const bybitWalletExSwithWallet = () => {
    window.top?.bybitWallet.request({
      method: 'switchWallet',
      params: [
        {
          walletType: walletTypeList,
          chainType: WalletChainTypes.EVM,
        },
      ],
    });
  };

  //
  const handleClick = async () => {
    // console.log(walletTypeList, thirdConnected);
    // 仅支持云钱包的活动
    if (onlySupport.cloud) {
      if (cloudConnected) {
        if (!isCreatedCloudWallet) {
          createWallet();
          return;
        }
        if (evmWalletInfo.address) {
          // 非云钱包
          if (walletType !== WalletType.CLOUD) {
            switchToBrowser();
          }
        } else {
          createWallet();
        }
      } else {
        openLoginModal();
      }
      // 仅支持bybit插件钱包==>助记词或私钥
    } else if (onlySupport.bybitWalletEx) {
      // 当前为云钱包连接
      if (isBrowserWallet) {
        // 插件钱包已连接
        if (thirdConnected) {
          // 连接的插件钱包 是 bybit插件钱包
          if (isBybitWalletExtension) {
            let bybitWalletInfo = {
              accountId: '',
              walletType: WalletType.CLOUD,
              addressChain: [] as BybitWalletChain[],
            };
            try {
              bybitWalletInfo =
                (await window.top?.bybitWallet?.request({
                  method: 'getWalletInfo',
                })) || {};
            } catch (e) {
              console.log(e);
            }
            //插件钱包类型是云钱包
            if (bybitWalletInfo.walletType === WalletType.CLOUD) {
              bybitWalletExSwithWallet();
            } else {
              switchToThirdParty();
            }
          } else {
            // 连接的插件钱包 不是 bybit插件钱包，断开插件钱包
            disconnectThird();
            connectBybitWallet([WalletType.MNEMONIC_PHRASE]);
          }
        } else {
          connectBybitWallet([WalletType.MNEMONIC_PHRASE]);
        }
      } else if (thirdConnected) {
        // 当前连接的插件钱包
        // 链接了插件钱包但是为其他三方钱包
        if (!isBybitWalletExtension) {
          disconnectThird();
          return;
        } else {
          if (!walletTypeList.includes(walletType)) {
            bybitWalletExSwithWallet();
          }
        }
        // handleOpenConnectModal();
      } else {
        connectBybitWallet([WalletType.MNEMONIC_PHRASE]);
      }
    } else {
      if (supportAll) {
        if (
          cloudConnected &&
          walletType === WalletType.CLOUD &&
          !evmWalletInfo.address
        ) {
          createWallet();
        }
        if (thirdConnected && !walletTypeList.includes(walletType)) {
          disconnectThird();
          openLoginModal();
        }
      }
    }
    typeof props.onOk === 'function' && props.onOk();
  };

  // 按钮文案
  const buttonText = useMemo(() => {
    const text: any = fm('switchWallet');
    // 仅支持云钱包
    if (onlySupport.cloud) {
      if (!cloudConnected) {
        return fm('login');
      } else {
        // 已登陆云钱包
        if (walletType === WalletType.CLOUD && !evmWalletInfo.address) {
          return fm('wallet_connect');
        }
        if (walletType !== WalletType.CLOUD) {
          if (!isCreatedCloudWallet) {
            return fm('wallet_connect');
          }
          return text;
        }
      }
    }
    // 仅支持插件钱包
    if (onlySupport.bybitWalletEx) {
      if (!thirdConnected) {
        return fm('connect_wallet');
      } else {
        return text;
      }
    }
    // 云钱包登录且未创建钱包
    if (
      cloudConnected &&
      walletType === WalletType.CLOUD &&
      !evmWalletInfo.address
    ) {
      return fm('wallet_connect');
    }
    // 其他
    return text;
  }, [
    evmWalletInfo,
    walletType,
    onlySupport,
    thirdConnected,
    fm,
    isLogin,
    isCreatedCloudWallet,
  ]);

  return type === 'textlink' ? (
    <TextLink onClick={handleClick}>{buttonText}</TextLink>
  ) : (
    <Button variant="primary" className="!w-full" onClick={handleClick}>
      {buttonText}
    </Button>
  );
}
